import { createElement } from 'react';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { store } from 'src/common/redux/configure-store';
import { openCashDrawer } from 'src/devices/cash-drawer-operations';
import { showAutoCloseOnCashDrawerCloseMessage } from 'src/messages/business-logic/auto-close-on-cash-drawer-close-message';
import { EmeraldDialogTypes } from '../../../common/enumerations/emerald-dialog-types';

export const openDrawer = (): Promise<boolean> => {
  return openCashDrawer();
};

export const closeDrawer = (): void => {
  if (store.getState().cashDrawer.open) {
    const modalMessage: IMessageModal = {
      message: 'CashDrawerCloseAction',
      type: EmeraldDialogTypes.Info,
      subMessage: 'CashDrawerCloseSubMessage',
      buttonComponent: createElement('div'),
      disableBackdropClick: true,
    };
    showAutoCloseOnCashDrawerCloseMessage(modalMessage);
  }
};
